export {
  buildPriceBarcodeEan13,
  buildPricePesosBarcodeEan13,
  buildWeightBarcodeEan13,
  computeEan13CheckDigit,
  normalizeScalePlu,
  parseScaleBarcodeProfile,
  parseWeightBarcode,
  SCALE_BARCODE_PROFILES,
  trimScalePluLeadingZeros,
  weightBarcodeToCartQuantity,
  type ParsedWeightBarcode,
  type ScaleBarcodeProfile,
  type WeightBarcodeEmbeddedUnit,
  type WeightBarcodeMode,
} from './parseWeightBarcode';
